import { BorderClear } from "@mui/icons-material";
import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fatch-music-listing--------------------------
export const getUserListApi = async (data) => {
  const endPoint = `/admin/user/list`;
  return await axios.post(endPoint, data, { ...setJwtToken(), timeout: 60000 });
};

export const sendUserWhatsappApi = async (data) => {
  return axios.post("/admin/user/whatsapp-send", data, setJwtToken());
};

export const getHighSpendingUserListApi = async (data) => {
  const endPoint = `/admin/user/list/high-spending`;
  return await axios.post(endPoint, data, setJwtToken());
};


// ---------------------waiting-listing--------------------------
export const waitlistApi = async (data) => {
  const endPoint = `/admin/user/list/waitlist`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------Booked-listing--------------------------
export const bookedWaitlistApi = async (data) => {
  const endPoint = `/admin/user/list/booked-waitlist`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------cancel-waitlist--------------------------
export const cancelWaitlistApi = async (data) => {
  const endPoint = `/admin/user/cancel-waitlist`;
  return await axios.delete(endPoint, { data, ...setJwtToken() });
};

// ---------------------end-waitlist--------------------------
export const endWaitlistApi = async (data) => {
  const endPoint = `/admin/waitlist/end-waitlist`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------failed-listing--------------------------
export const FailedConsulatationApi = async (data) => {
  const endPoint = `/admin/user/list/failed`;
  return await axios.post(endPoint, data, setJwtToken());
};


// ---------------------Missed-listing--------------------------
export const Missed_callAPi = async (data) => {
  const endPoint = `/admin/user/list/missed`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------Completed-listing--------------------------
export const Completed_callAPi = async (data) => {
  const endPoint = `/admin/user/list/completed`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------Recreate 1st consultation (append _updatedbyadmin to deviceUsedToken)--------------------------
export const recreateFirstConsultationApi = async (data) => {
  const endPoint = `/admin/waitlist/recreate-first-consultation`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ---------------------Recreate 2nd consultation --------------------------
export const recreateSecondConsultationApi = async (data) => {
  const endPoint = `/admin/waitlist/recreate-second-consultation`;
  return await axios.post(endPoint, data, setJwtToken());
};

// Send only the consultation selected from the "Used For Query" column.
export const markUsedForQueryApi = async (data) => {
  const endPoint = `/admin/user/used-for-query`;
  return await axios.post(endPoint, data, setJwtToken());
};


// ---------------------Progress-listing--------------------------
export const Progress_callAPi = async (data) => {
  const endPoint = `/admin/user/list/progress`;
  return await axios.post(endPoint, data, setJwtToken());
};
  
//--------/list_for_marketing---------------
export const getUserListApimarketing = async (data) => {
  const endPoint = `/admin/user/list_marketing`;
  return await axios.post(endPoint, data, setJwtToken());
};
//------------/add_order_task_remedy----------
export const addRemedy = async (formData) => {
  const endPoint = `/admin/user/remedy/add`;
  console.log("formData: ", formData);
  return await axios.post(endPoint, formData, setJwtToken());
};

// ---------------------utm-management--------------------------
export const fetchUtmManagementApi = async (data) => {
  const endPoint = `/admin/utm-management`;
  return await axios.get(endPoint, { params: data }, setJwtToken());
};

// -----------remedy--------------

export const fetchAOCList = async (concernId = null, concernRemedyId = null) => {
  console.log("concernId: ", concernId);
  console.log("concernRemedyId: ", concernRemedyId);
  let endPoint = `/admin/user/remedy?type=AREAOFCONCERN`; // Default case

  if (concernId) {
    endPoint = `/admin/user/remedy?type=REMEDY&areaOfConcernId=${concernId}`;
  }

  if (concernRemedyId) {
    endPoint = `/admin/user/remedy?type=DESCRIPTION&areaOfConcernRemedyId=${concernRemedyId}`;
  }

  return await axios.get(endPoint, setJwtToken());
};




//------------------- Fetch-otp--------------------------------------------

export const sendOtpAPi = async (data) => {
  const endPoint = `/admin/send_csv_otp`;
  return await axios.post(endPoint, { number: data }, setJwtToken());
};

// export const verifyOtpApi =async (item) => {
//   const endpoint = `/admin/verify_csv_otp`
//   const response = await fetch(
//     `${BASE_URL}/admin/verify_csv_otp`,
//     {
//       method: 'POST',
//       headers: {
//         // 'App-Os': 'iOS',
//         "Content-Type":"application/json",
//         'App-Device-Language': 'en-GB',
//         'App-Language': 'en-GB',
//       },
//       body:JSON.stringify(body)
//     },
//   );
//   return response.json();}
// ---------------------fatch-Deleted-User-listing--------------------------
export const getDeletedUserListApi = async (data) => {
  // Flatten the data structure to handle nested objects properly
  const flattenedData = {};
  
  // Add top-level properties
  Object.keys(data).forEach(key => {
    if (key !== 'filter' && key !== 'sortBy') {
      flattenedData[key] = data[key];
    }
  });
  
  // Add filter properties with 'filter.' prefix
  if (data.filter && typeof data.filter === 'object') {
    Object.keys(data.filter).forEach(key => {
      if (data.filter[key] !== undefined && data.filter[key] !== '') {
        flattenedData[`filter.${key}`] = data.filter[key];
      }
    });
  }
  
  // Add sortBy if it exists
  if (data.sortBy) {
    flattenedData.sortBy = data.sortBy;
  }
  
  const endPoint =
    `/admin/user/delete/list` +
    "?" +
    new URLSearchParams(flattenedData).toString();

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------change-status-banner---------------------------
export const changeUserStatus = async (data) => {
  const endPoint = `/admin/user/block_unblock`;
  return await axios.put(endPoint, data, setJwtToken());
};

export const updateUserWallet = async (data) => {
  const endPoint = `/admin/user/update_wallet`;
  return await axios.put(endPoint, data, setJwtToken());
};

// ---------------------get-user-detail---------------------------
export const getSelectedUserDetail = async (data) => {
  const endPoint =
    `/admin/user/details` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
export const getNumericalAnalyticsApi = async (data) => {
  const endPoint =
    `/admin/user/numerical-analytics` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ---------------------get-user-statistics---------------------------
export const getUserStatisticsApi = async (data) => {
  const endPoint =
    `/admin/dashboard/date-wise-data-percentage-user-management` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const excelDownloadHandler = async (data) => {
  const endPoint = `/admin/user/download`;
  //  + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken());
};

// User History
export const getUserHistoryApi = async (data) => {
  const endPoint =
    `/admin/user/history` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Logs History
export const getLogsHistoryApi = async (data) => {
  const endPoint =
    `https://chat-server.vedicmeet.com:8000/api/chats/get-logs-by-waitlist` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};



// Logout from all device

export const logoutUserFromAllDevice = async (data) => {
  const endPoint =
    `/admin/user/log_out` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// User Transaction History
export const getUserTransactionHistoryApi = async (data) => {
  const endPoint =
    `/admin/user/transactions` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Customer Consultant User Support: leave-a-message threads for user
export const getLeaveAMessageThreadsApi = async (data) => {
  const endPoint =
    `/admin/user/leave-a-message-threads` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Customer Consultant User Support: messages for a thread
export const getLeaveAMessageMessagesApi = async (data) => {
  const endPoint =
    `/admin/user/leave-a-message-messages` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
